module.exports = __webpack_public_path__ + "img/Marjorie Evasco.ace88c3e.jpg";